<template>
  <div class="part">
    <div class="container">
      <div class="square">
        <div class="square_header">
          <h3>快速发布采购项目</h3>
          <h4>多个项目请将图纸压缩后上传，我们的工程师团队将尽快与您确认</h4>
        </div>
        <el-row type="flex" class="square_body" justify="space-between">
          <el-col :span="13">
            <el-form ref="form" :model="formData" label-width="120px">
              <el-form-item>
                <h4 slot="label">
                  <span></span>项目编号:
                </h4>
                <div class="form_id">{{formData.id}}</div>
              </el-form-item>
              <el-form-item label="*项目名称:">
                <el-input v-model="formData.name" placeholder="请输入项目名称"></el-input>
              </el-form-item>
              <el-form-item label="*图纸与技术文档:">
                <el-upload
                  class="upload-demo"
                  action="/v2/validate/Upload"
                  :headers="myHeaders"
                  :on-preview="handlePreview"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleRemove"
                  multiple
                  :limit="9"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <span class="form_updata_span">（多图纸请打包上传）</span>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
              <el-form-item label="*样件数量:">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入样件数量"
                  v-model="formData.unit_num"
                ></el-input>
              </el-form-item>
              <el-form-item label="*货运条款:">
                <el-select v-model="formData.freight" placeholder="请选择货运条款" style="display:block;">
                  <el-option
                    v-for="(item,index) in freightOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="省市区" :label-width="formLabelWidth">
                <v-distpicker @selected="onSelected"></v-distpicker>
              </el-form-item>
              <el-form-item label="*期望发货日期：">
                <el-date-picker
                  v-model="formData.freight_date"
                  type="date"
                  placeholder="选择发货日期日期"
                  style="display:block;width: auto;"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="*详细需求：">
                <el-input
                  type="textarea"
                  :rows="8"
                  placeholder="请描述详细需求"
                  v-model="formData.demands"
                ></el-input>
                <p class="form_p">
                  请务必告诉我们
                  <strong>零件工艺、材料、公差</strong>等信息，详细的需求有助于我们快速为您报价！
                </p>
              </el-form-item>
              <el-form-item>
                <div class="form_submit">
                  <el-button type="primary" class="form_submit_bt" @click="createDemand()">提交需求</el-button>
                </div>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="11">
            <div class="bulletin">
              <h6>我们的承诺</h6>
              <ul>
                <li>
                  <div>
                    <i class="el-icon-s-order" style="color: rgb(66,167,239);"></i>
                    <span>图纸保密</span>
                    <p>我们承诺在未经您的许可，不会把图纸泄露给任何第三方个人或机构，以保障图纸的安全</p>
                  </div>
                </li>
                <li>
                  <div>
                    <i class="el-icon-s-opportunity" style="color: rgb(64,215,101);"></i>
                    <span>质量保证</span>
                    <p>所有零件均通过专业检测工程师检测并确认后发货</p>
                  </div>
                </li>
                <li>
                  <div>
                    <i class="el-icon-date" style="color: rgb(239,161,83);"></i>
                    <span>交期保障</span>
                    <p>全程订单追踪，确保项目及时交付</p>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import VDistpicker from "v-distpicker";
import { axios } from "@/utils/request";
import store from "@/store";
export default {
  name: "RequireSquare",
  components: {
    VDistpicker
  },

  data() {
    return {
      value1: true,
      phone: "",
      formLabelWidth: "120px",
      myHeaders: {
        "Access-Token": Vue.ls.get(ACCESS_TOKEN)
      },
      id: [],
      formData: {
        id: "",

        name: "",
        unit_num: "",
        freight: "",
        freight_date: "",
        demands: "",
        drawing: []
      },
      freightOptions: [
        {
          value: "EXW - 工厂交货",
          label: "EXW - 工厂交货"
        },
        {
          value: "FCA - 交至承运人",
          label: "FCA - 交至承运人"
        },
        {
          value: "FAS - 船边交货",
          label: "FAS - 船边交货"
        },
        {
          value: "FOB - 装运港船上交货",
          label: "FOB - 装运港船上交货"
        },
        {
          value: "CFR - 成本加运费",
          label: "CFR - 成本加运费"
        },
        {
          value: "CIF - 成本、保险加运费付至",
          label: "CIF - 成本、保险加运费付至"
        },
        {
          value: "CPT - 运费付至",
          label: "CPT - 运费付至"
        },
        {
          value: "CIP - 运费、保险费付至",
          label: "CIP - 运费、保险费付至"
        },
        {
          value: "DDP - 完税后交货",
          label: "DDP - 完税后交货"
        },
        {
          value: "DAT – 目的地或目的港的集散站交货",
          label: "DAT – 目的地或目的港的集散站交货"
        },
        {
          value: "DAP – 目的地交付",
          label: "DAP – 目的地交付"
        },
        {
          value: "OTH - 其他",
          label: "OTH - 其他"
        },
        {
          value: "DDU - 未完税交货",
          label: "DDU - 未完税交货"
        }
      ],
      fileList: []
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    createDemand() {
      this.formData.freight_date = moment(this.formData.freight_date).format(
        "YYYY-MM-DD"
      );
      var data = this.formData;
      
      
          var pic = []
          for (let i = 0 ; i < this.formData.drawing.length ; i ++){
            let file = {
                fileId : 0,
                fileName : "",
                filePath : "https://yungc.2mould.com/upload/" + this.formData.drawing[i],
                fileSize : 28,
                msg : null,
                success : true
            }
            pic.push(file)
          }

        this.phone = store.getters.userInfo.phone;
        
        var myHeaders = new Headers();
        myHeaders.append(
          "Cookie",
          '{"MiniApp-Signature":"o2EHD5PHCQtVjBpAxqWAupb2f3pc","AppId":"wx984b39fc09e7fe9f"}'
        );
        myHeaders.append(
          "Authorization",
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjQxOTgiLCJOYW1lIjoi6YOP5a6j5YuHIiwiaHR0cDovL3d3dy5hc3BuZXRib2lsZXJwbGF0ZS5jb20vaWRlbnRpdHkvY2xhaW1zL3RlbmFudElkIjoiMTY3MCIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6IkFkbWluIiwiUm9sZUlkcyI6IjQwNDciLCJzdWIiOiI0MTk4IiwianRpIjoiM2IwNGY5MDAtN2I2ZC00MDFhLTgyNWItNjY0Y2NlN2JkNTllIiwiaWF0IjoxNjAwMjE5NTc4LCJuYmYiOjE2MDAyMTk1NzgsImV4cCI6MTYzMTc1NTU3OCwiaXNzIjoiTWFzdGVyIiwiYXVkIjoiTWFzdGVyIn0.IXAiBGXsnqB4d9Uhsa0vgas-nPhdry_PgJZNMiGdwKc"
        );
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          ArticleFiles: pic,
          Content: this.formData.demands,
          PhoneNumber: this.phone
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };
        console.log(requestOptions);
        this.$http
        .post("/v2/validate/CreateDemand", { data, id: this.id })
        .then(res => {
          fetch(
          "/test/api/services/moments/MomentsArticle/FormSave",
          requestOptions
        ).then(reslut => {
          console.log("同步成功");
        });
          this.$router.push({ name: "DemandSquare" })
        })
        .catch(error => {});
      
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code == 0) {
        console.log(response.data);
        this.formData.drawing.push(response.data);
        console.log(file);
      } else {

        alert(response.err);
      }
    },
    getDemandId() {
      axios({
        url: "/v2/validate/GetDemandId",
        methods: "get"
      })
        .then(res => {
          this.formData.id = res.data;
        })
        .catch(error => {
          console.log(error);
        });
      //   this.$http.get('/v2/validate/GetDemandId',
      //     {

      //     })
      // 	.then(res =>{
      //         console.log(res.data)
      //         this.formData.id = res.data
      // 	}).catch(error =>{
      //             console.log(error)
      // 			alert(error)

      // 	})
    },
    onSelected(data) {
      this.formData.province = data.province.value;
      this.formData.city = data.city.value;
      this.formData.area = data.area.value;
    }
  },
  created() {
    this.id = this.$route.params.id;
    console.log(this.id);
    this.getDemandId();
    console.log(store.getters.userInfo.phone);
  }
};
</script>

<style scoped>
.part {
  background-color: #f2f2f2;
}
.square {
  padding: 30px 0 100px;
}
.square_header {
  background-image: url("../../assets/images/square-header.png");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
  height: 120px;
  padding-left: 20px;
}
.square_header h3 {
  color: #fff;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 24px;
  padding: 20px 0 25px;
  text-shadow: 0 3px 0 #184782;
}
.square_header h4 {
  color: #fff;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 16px;
  text-shadow: 0 2px 0 #184782;
  font-weight: lighter;
}
.square_body {
  background: white;
  padding: 60px 60px 165px 30px;
}
.form_updata {
  font-size: 14px;
  padding: 12px 26px;
}
.form_updata_span {
  font-size: 12px;
  color: rgb(136, 136, 136);
  margin-left: 15px;
}
.form_p {
  line-height: 18px;
  padding-top: 10px;
  font-size: 12px;
  color: rgb(136, 136, 136);
}
.form_submit_bt {
  display: block;
  width: 100%;
  font-size: 18px;
}
.form_submit >>> .el-button--primary {
  background-color: #066eb7 !important;
  border-color: #066eb7 !important;
  border-radius: 4px !important;
}
.form_submit >>> .el-button--primary:hover {
  background-color: #0560a1 !important;
  border-color: #0560a1 !important;
  border-radius: 4px !important;
}
.bulletin {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 10px 14px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  min-height: 440px;
  padding: 30px;
  width: 370px;
  margin: 0 auto;
}
.bulletin li {
  margin-top: 38px;
}
.bulletin h6 {
  color: #333;
  font-size: 18px;
  line-height: 18px;
}
.bulletin i {
  width: 29px;
  font-size: 16px;
  background: rgb(237, 237, 237);
  padding: 5px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 100%;
}
.bulletin span {
  color: #333;
  font-size: 14px;
  margin-left: 15px;
}
.bulletin p {
  color: #888;
  font-size: 12px;
  line-height: 20px;
  margin-top: 5px;
  padding-left: 44px;
}
</style>